const ENV_CONFIG_ATTRIBUTES = {
    CLIENT_ID: 'CLIENT_ID',
    SCOPE: 'SCOPE',
    AUTH_URL: 'AUTH_URL',
    AUTH_THEME: 'AUTH_THEME',
    TOKEN_URL: 'TOKEN_URL',
    REDIRECT_URI: 'REDIRECT_URI',
    HOME_PAGE_URL: 'HOME_PAGE_URL',
    MY_PAGES_URL: 'MY_PAGES_URL',
    VERSION: 'VERSION',
    SENTRY_URL: 'SENTRY_URL',
    LANGUAGE: 'LANGUAGE',
    CUSTOMER_SERVICE_URL: 'CUSTOMER_SERVICE_URL',
};

export { ENV_CONFIG_ATTRIBUTES };
